export default __webpack_public_path__ + "static/media/pin2.3b381fd6.png";